import { useId } from 'react'

export const DiamondIcon = () => {
  const id = useId()
  const gradientId = `diamond-grad-${id}`

  return (
    <svg
      data-testid="diamond-icon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="mt-1 shrink-0"
      aria-hidden
    >
      <path d="M16 12V3.99996L8.00005 0L0 3.99996V12L8.00005 16L16 12Z" fill={`url(#${gradientId})`} />
      <defs>
        <linearGradient id={gradientId} x1="8" y1="0" x2="8" y2="30" gradientUnits="userSpaceOnUse">
          <stop stopColor="#B7ECDA" />
          <stop offset="1" stopColor="#40AD87" />
        </linearGradient>
      </defs>
    </svg>
  )
}
